import { CallingState, useCall, useCallStateHooks, useConnectedUser, VideoPreview } from "@stream-io/video-react-sdk";
import { AcceptCallButton, HangUpCallButton, RejectCallButton, ToggleAudioButton, ToggleVideoButton } from "./call-controls";
import { useEffect } from "react";
import profileImagedefault from "../../assests/defaultImage.png"


export const UserCallInfo = () => {
    const call = useCall()
    const connectedUser = useConnectedUser();
    const { useCallMembers, useCallCallingState } = useCallStateHooks();
    const members = useCallMembers();
    const callingState = useCallCallingState()
    const membersToShow = (members || []).map(({ user }) => user).filter((user) => user.id !== connectedUser.id) || [];
    const { name, image } = membersToShow[0] ?? {}


    return (
        <div>
            <div className="flex justify-between items-center p-2">
                <div>
                    <h1 className="text-xl font-semibold">{name}</h1>
                    {(call.isCreatedByMe || callingState === CallingState.JOINING) && <p className="text-sm text-gray-400">
                        {callingState}
                    </p>}
                </div>
                {/* <button>
                    <MdArrowDropDown className="w-5 h-5 text-gray-300 hover:text-white transition-all" />
                </button> */}
            </div>

            <div className="flex justify-center mt-10">
                <img
                    src={image || profileImagedefault}
                    alt="User Profile"
                    className="w-32 h-32 rounded-full border-4 border-customGold shadow-md"
                />
            </div>
        </div>
    )
}


export const RingingCallControl = () => {
    const call = useCall()
    const { useCallCustomData } = useCallStateHooks();
    const { type } = useCallCustomData();


    return (
        <div className="flex justify-between mt-auto bg-customGray rounded-lg p-4 w-full shadow-lg">
            {call.isCreatedByMe ? <ToggleAudioButton /> : <AcceptCallButton />}

            {type === 'video' && <ToggleVideoButton />}

            {call.isCreatedByMe ? <HangUpCallButton /> : <RejectCallButton />}
        </div>
    )
}

const CustomVideoPreview = () => {
    const connectedUser = useConnectedUser();
    const { useCallMembers, useCallCallingState } = useCallStateHooks();
    const callingState = useCallCallingState()
    const members = useCallMembers();
    const membersToShow = (members || []).map(({ user }) => user).filter((user) => user.id !== connectedUser.id);
    const { name, image } = membersToShow[0] ?? {}

    return (
        <div className="flex justify-center items-center relative">
            <div className="absolute top-0 left-0 bg-black/70 z-20 p-4 flex gap-2 items-center">
                <img
                    className="w-16 h-16 rounded-full border-full border-customGold shadow-md" src={image || profileImagedefault} alt="User Profile"
                />
                <div>
                    <p className="text-white text-xl font-semibold">{name}</p>
                    <p className="text-white text-sm ">{callingState}</p>
                </div>
            </div>
            <VideoPreview />
        </div>
    )
}

const AudioRingingContent = ({ members, callingState, call }) => {
    const connectedUser = useConnectedUser();
    const membersToShow = (members || []).map(({ user }) => user).filter((user) => user.id !== connectedUser.id) || [];
    const { name, image } = membersToShow[0] ?? {}

    const callStateInfo = call.isCreatedByMe ? "Ringing..." : callingState === CallingState.RINGING ? "Ringing..." : "Connecting..."


    return (
        <div className="flex flex-col p-5 rounded-lg justify-center items-stretch relative bg-customDark border border-gray-600">
            <div className="flex items-center justify-between w-full mb-4">
                <div className="flex gap-2 items-center">
                    <img
                        src={image ||profileImagedefault}
                        alt="User Profile"
                        className="w-20 h-20 rounded-full border border-gray-600 shadow-md"
                    />
                    <div className="flex flex-col gap-2">
                        <p className="text-white text-xl font-semibold">{name}</p>
                        <p className="text-white text-sm animate-pulse">{callStateInfo}</p>
                    </div>
                </div>

                <div className="flex gap-4 items-center">
                    {call.isCreatedByMe ? <ToggleAudioButton /> : <AcceptCallButton />}
                    <HangUpCallButton />
                </div>
            </div>

            <div className="p-4 border-t border-t-gray-600 flex justify-center items-center">
                <button disabled className="text-white opacity-55 rounded-md p-3 w-full bg-gray-700 border border-gray-600 text-sm font-semibold">
                    Switch to video call
                </button>
            </div>

        </div>
    )
}


export const RingingCallComponent = () => {
    const call = useCall()
    const { useCallCustomData, useCameraState, useCallCallingState, useCallMembers } = useCallStateHooks();
    const members = useCallMembers();
    const callingState = useCallCallingState();
    const { status } = useCameraState();
    const customData = useCallCustomData();
    const { type } = customData;

    useEffect(() => {
        if (type === 'video' && callingState === CallingState.RINGING) {
            call.camera.enable()
        }
    }, [callingState, type, call.camera])

    return type === 'audio' ? <AudioRingingContent call={call} callingState={callingState} members={members} /> : (
        <div className={`text-white font-sans flex-1 mx-auto rounded-lg shadow-xl relative bg-customDark h-full flex flex-col ${type === 'video' ? '' : 'animate-pulse'}`}>
            <div className="w-full aspect-video">
                {type === 'video' && status === 'enabled' ? <CustomVideoPreview /> : <UserCallInfo />}
            </div>
            <RingingCallControl />
        </div>
    )
}